export default {
  "content": "<path d=\"M158.751 314.786C159.187 402.009 201.532 534 201.532 534H-99v-890h265.5s-33.778 121.212-21.766 198.112c12.227 78.27 55.895 141.384 59.486 240.877 3.872 107.3-45.929 139.551-45.469 231.797\" fill=\"#4141A2\"/>",
  "attrs": {
    "width": "205",
    "height": "430",
    "viewBox": "0 0 205 430",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};